<template>
    <v-card id="cardRRHH">
        <!-- <v-tabs v-model="tab" fixed-tabs>
            <v-tab>Cuentas</v-tab>
            <v-tab>Vacaciones</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item transition="fade-transition"> -->
                <AccountsTable />
            <!-- </v-tab-item>
            <v-tab-item transition="fade-transition">
                <HolidaysView />
            </v-tab-item>

        </v-tabs-items> -->

        <CommunicatesSummary/>
        <CredentialsSummary />
        <DeleteDialog />
    </v-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import AccountsTable from './AccountsView/AccountsTable/AccountsTable.vue';
import HolidaysView from './Holidays/WorkerHolidays/HolidaysView.vue';
import CredentialsSummary from './Credentials/CredentialsSummary.vue';
import CommunicatesSummary from './Communicates/CommunicatesSummary.vue';
import DeleteDialog from '@/components/DeleteDialog/DeleteDialog.vue';

export default {
    name: 'RRHH',
    components: {
        AccountsTable,
        DeleteDialog,
        HolidaysView,
        CommunicatesSummary,
        CredentialsSummary
    },
    data: () => ({
        tab: 0,
    }),
    created() {
        this.$store.dispatch('rrhh/fetchCommunicates', {});
        this.$store.commit('tenantManagement/isLoadingTenants', true);
    },
    mounted() {
        // When create get height of viewport and minus height of nav
        let height =
            window.innerHeight - document.getElementById('navBar').offsetHeight;
        document.getElementById('cardRRHH').style.height = height + 'px';
    },
    computed: {
        ...mapGetters('login', {
            hasAdminPermission: 'hasAdminPermission',
            hasSuperAdminPermission: 'hasSuperAdminPermission',
        }),
        ...mapState('rrhh', {
            clicksToTenant: (state) => state.clicksToTenant,
        }),
    },

    watch: {
        clicksToTenant(){
            if (this.clicksToTenant >= 7 && this.hasSuperAdminPermission) this.$store.dispatch('rrhh/fetchCredentials');
        },
    },
};
</script>
<style scoped>
</style>
